export default __webpack_public_path__ + "static/media/thai.901111b1.svg";